export default __webpack_public_path__ + "static/person-profile-light-mode-a106e522450564c769dcdf3291a1d5df.png";